import {colors} from "../../../config/charts/colors";

export const chartExample2 = {
  options: {
    scales: {
      yAxes: [
        {
          gridLines: {
            color: colors.gray[200],
            zeroLineColor: colors.gray[200]
          },
          ticks: {
            callback: function(value) {
              if (!(value % 10)) {
                //return '$' + value + 'k'
                return value;
              }
            }
          }
        },
        {
          gridLines: {
            color: colors.gray[300],
            zeroLineColor: colors.gray[200]
          },
          ticks: {
            callback: function(value) {
              if (!(value % 10)) {
                //return '$' + value + 'k'
                return value;
              }
            }
          }
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: function(item, data) {
          var label = data.datasets[item.datasetIndex].label || "";
          var yLabel = item.yLabel;
          var content = "RON ";
          if (data.datasets.length > 1) {
            content += label;
          }
          content += yLabel;
          return content;
        }
      }
    }
  },
  data: {
    labels: ["Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Total: ",
        data: [25, 20, 30, 22, 17, 29],
        maxBarThickness: 10,
        backgroundColor: "rgba(233, 236, 239, .7)",
        borderColor: "rgba(233, 236, 239, .7)",
        hoverBackgroundColor: "rgba(233, 236, 239, 1)",
        hoverBorderColor: "rgba(233, 236, 239, 1)",
        borderWidth: "1",
      },
      {
        label: "Used: ",
        data: [15, 19, 25, 19, 9, 2],
        maxBarThickness: 10,
        backgroundColor: colors.theme.default,
        borderColor: "rgba(233, 236, 239, .7)",
        hoverBackgroundColor: "rgba(233, 236, 239, 1)",
        hoverBorderColor: "rgba(233, 236, 239, 1)",
        borderWidth: "1",
      },
      {
        label: "Available: ",
        data: [15, 19, 25, 19, 9, 2],
        maxBarThickness: 10,
      },
      {
        label: "Pending: ",
        data: [15, 19, 25, 19, 9, 2],
        maxBarThickness: 10,
      },
    ]
  }
};
